import React, { useState } from "react";
import CheckWithDate from "../CheckWithDate";
import ViewButton from "../Buttons/ViewButton";
import ViewClientIntakeAndBagSearchChecklist from "../forms/ViewClientIntakeAndBagSearchChecklist";
import StandardDrawer from "../forms/StandardDrawer";

function FormLineIntakeAndBagSearchList(props) {
  const [showViewModal, setShowViewModal] = useState(false);

  const openViewModal = (event) => {
    event?.stopPropagation?.();
    setShowViewModal(true);
  };

  const closeViewModal = (event) => {
    event?.stopPropagation?.();
    setShowViewModal(false);
  };

  const handleRowKeyDown = (event) => {
    if (props.signed && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      openViewModal();
    }
  };

  return (
    <div
      className={
        `${
          props.color === "1" ? "formLine light-grey-form" : "formLine grey-form"
        } ${props.signed ? "form-row-clickable" : ""}`
      }
      onClick={props.signed ? openViewModal : undefined}
      onKeyDown={handleRowKeyDown}
      role={props.signed ? "button" : undefined}
      tabIndex={props.signed ? 0 : undefined}
    >
      <StandardDrawer
        open={showViewModal}
        onClose={closeViewModal}
        className="bag-checklist-drawer-paper"
        contentClassName="bag-checklist-drawer-content"
      >
        <div
          className="standard-drawer-form-wrapper"
          onClick={(event) => event.stopPropagation()}
          onKeyDown={(event) => event.stopPropagation()}
        >
          <ViewClientIntakeAndBagSearchChecklist
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeViewModal}
            {...props}
          />
        </div>
      </StandardDrawer>
      <div className="formLineBlock1">{props.title}</div>
      <div className="formLineBlock2">
        {props.signed !== true || props.signed === undefined ? (
          <CheckWithDate checked={false} content="Not signed" />
        ) : (
          <CheckWithDate checked={true} content={props.date} />
        )}
      </div>
      <div className="formLineBlock3">
        {props.signed ? (
          <ViewButton handleOpen={openViewModal} {...props} />
        ) : (
          ""
        )}

        {/* <DownloadButton2 /> */}

        {/* <CheckButton />
        <PrintButton />
        <MailButton /> */}
      </div>
    </div>
  );
}

export default FormLineIntakeAndBagSearchList;
